const menuItem = (t, f, tid, disabled = false) => ({
  action: (e, id) => f(id),
  text: t(tid),
  disabled
});

export default menuItem;
